<template>
	<div class="FundInfo" >
		<div class="header_ContentBox p-l-10 p-r-10" >
			<i class="zb zb-moneynt Icon" ></i>
			<span class="header_text">/ 企业管理 / 签约费率&结算通道</span>
		</div>
		<div class="companyOperatingRecordBox content_Box box-shadow m-t-15" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<div class="m-t-20">
				<div  class="p-l-10 p-r-10" style="height: 40px;">
					<span class="fl" style="display:block;height:40px;line-height:40px;">姓名：<span class="cz-font cz-qy cursor-pointer">欧阳娜娜</span></span>
					<span class="resetBtn m-r-5 fr" style="display:block;" @click="$router.go(-1)">返回</span>
				</div>
				<template>
					<el-table :data="tableData" stripe style="width: 100%">
						<el-table-column label="#" prop="operator"></el-table-column>
						<el-table-column label="银行卡号" prop="operator"></el-table-column>
						<el-table-column label="银行名称" prop="operator"></el-table-column>
						<el-table-column label="分行/支行" prop="operator"></el-table-column>
					</el-table>
				</template>
				<!-- 分页 -->
				<div class="block regPagination">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
					 :page-sizes="pageSize" :page-size="pageSizeNow" layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		
		<!-- 提现 -->
		<el-dialog title="余额提现" :visible.sync="TXShow" width="500px" :close-on-click-modal="false">
			<div class="auditCentent">
				<div class="clear row-info">
					<div class="fl title-key">可提现金额：</div>
					<div class="fl list-cont"> {{available_balance}} </div>
				</div>
				<div class="clear row-info">
					<div class="fl title-key">收款银行：</div>
					<div class="fl list-cont">   </div>
				</div>
				<div class="clear row-info">
					<div class="fl title-key">收款账户：</div>
					<div class="fl list-cont">   </div>
				</div>
				<div class="clear row-info">
					<div class="fl title-key">收款账号：</div>
					<div class="fl list-cont">   </div>
				</div>
				<div class="clear row-info m-t-10">
					<div class="fl title-key">提现金额：</div>
					<div class="fl list-cont"> <el-input></el-input>  </div>
				</div>
				<div class="clear row-info m-t-10">
					<div class="fl title-key">支付密码：</div>
					<div class="fl list-cont m-r-10"> <el-input></el-input> </div>
					 <span style="line-height:40px;">6位数字</span>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<span class="btnOK" @click="TxBtn">确定</span>
			</div>
		</el-dialog>
		
		
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	export default {
		name: 'FundInfo',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				available_balance:'', //账户余额
				tableData: [], //流水数据
				//	分页
				total: 0, //总数
				pageNum: 1, //当前页
				pageSize: [10, 20, 50, 100,200,500], //每页展示条数
				pageSizeNow: 50, //当前每页多少行
				
				TXShow:false, //提现
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { //是否登录
					window.location = 'login.html';
					return;
				} 
				this.getMoneyDetail();
			},
			
			txShow(){	//提现
				this.TXShow = true;
			},
			TxBtn(){  //提现审核
				console.log('提现');
			},
			getMoneyDetail(){ //获取流水明细
				let fn = new FormData();
				fn.append('page', this.pageNum); //文件
				fn.append('page_size', this.pageSizeNow); //页码
				this.$http.post(this.url + '/zhongfy/bank/MoneyDetail',fn).then((res) => {
					let data = res.data;
					if (data.code == '200' || data.msg == '成功') {
						this.tableData = data.data.list;
						for(let i = 0 ; i < this.tableData.length ; i++){
							this.tableData[i].change_amount = Number(this.tableData[i].change_amount).toFixed(2);
							this.tableData[i].account_balance = Number(this.tableData[i].account_balance).toFixed(2);
						}
						this.total = data.data.total;
					} else if (data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error('企业未开通银行支付');
						return;
					}
				}, (err) => {
					this.$message.error('网络错误');
					return;
				});
			},
			handleCurrentChange(val) { //切换页数
				this.pageNum = val;
				this.getMoneyDetail(); 
			},
			handleSizeChange(val) { //切换每页条数
				this.pageSizeNow = val;
				this.pageNum = 1;
				this.getMoneyDetail();
			},
		},
		filters: {
		
		},
	}
</script>

<style scoped>

	.demo-table-expand {
		font-size: 0;
		background: #f5f6fa;
		border: 1px solid #EBEEF5;
		padding: 15px;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.financialDetails_title {
		height: 30px;
		font-size: 16px;
		padding-left: 10px;
		border-bottom: 1px solid #E8E8E8;
		color: #333333;
		margin-bottom: 15px;
	}
	.moneyShow{
		padding-left: 10px;
	}
	.moneyShow .content{
		height: 36px;
		line-height: 36px;
	}
	.moneyShow .title{
		line-height: 40px;
	}
	.moneyShow .content .balance{
		font-size: 30px;
		color: var(--theme-red);
		font-family: 'Impact', sans-serif;
	}
	.moneyShow .content .freeze{
		font-size: 30px;
		color: var(--zfy-blue);
	}
</style>



// WEBPACK FOOTER //
// src/components/BankList.vue